// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointValueFromJSON, DatapointValueToJSON, } from './';
export function DatapointsSeriesFromJSON(json) {
    return {
        'date': !exists(json, 'date') ? undefined : new Date(json['date']),
        'datapoints': !exists(json, 'datapoints') ? undefined : json['datapoints'].map(DatapointValueFromJSON),
    };
}
export function DatapointsSeriesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'date': value.date === undefined ? undefined : value.date.toISOString(),
        'datapoints': value.datapoints === undefined ? undefined : value.datapoints.map(DatapointValueToJSON),
    };
}
